/** @typedef {'flights' | 'hotels' | 'both'} CampaignProduct */

/** Stable product keys — pages must use these, never raw API strings. */
export const PRODUCTS = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
  BOTH: 'both',
};

/** @type {CampaignProduct[]} */
export const VALID_PRODUCTS = Object.values(PRODUCTS);

/**
 * @param {unknown} product
 * @returns {product is CampaignProduct}
 */
export function isValidProduct(product) {
  return typeof product === 'string' && VALID_PRODUCTS.includes(/** @type {CampaignProduct} */ (product));
}

/**
 * @param {unknown} product
 * @returns {CampaignProduct | null}
 */
export function normalizeProduct(product) {
  return isValidProduct(product) ? product : null;
}
